import { render, staticRenderFns } from "./indicators.vue?vue&type=template&id=0ea9274c&scoped=true"
import script from "./indicators.vue?vue&type=script&lang=js"
export * from "./indicators.vue?vue&type=script&lang=js"
import style0 from "./indicators.vue?vue&type=style&index=0&id=0ea9274c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9274c",
  null
  
)

export default component.exports